import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import styles from './index.module.css'
import { actionCreators } from '../../store'
import menuSearchIcon from '../../../../statics/menu_search_icon.png'


const FilterBox = () => {
    const dispatch = useDispatch()
    let datetime_category_list = useSelector(state => state.get('collect').get('datetime_category_list')).toJS()
    let content_category_list = useSelector(state => state.get('collect').get('content_category_list')).toJS()

    const handleSelectFilter = (value) => {
        datetime_category_list.forEach(element => {
            if (element.value === value) {
                element.active = true
            } else {
                element.active = false
            }
        })

        dispatch(actionCreators.filterCategoryListAction(datetime_category_list))
    }

    const handleContentChange = (value) => {
        content_category_list.forEach(element => {
            if (element.value === value) {
                element.active = true
            } else {
                element.active = false
            }
        })

        dispatch(actionCreators.contentCategoryListAction(content_category_list))
    }

    return (
        <div className={styles.container}>
            <div className={styles.top}>
                <div className={styles.section}>
                    <div className={styles.section_box}>
                        {
                            datetime_category_list.map((item) => {
                                return (
                                    <div
                                        key={item.value}
                                        className={`${styles.section_butn} ${item.active ? styles.section_butn_active : ''}`}
                                        onClick={() => {handleSelectFilter(item.value)}}
                                    >
                                        {item.label}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className={styles.search_box}>
                    <input
                        type={"text"}
                        placeholder={'搜索'}
                        className={styles.search}
                        // onChange={this.onSearchChange.bind(this)}
                        // value={this.props.menu_search_content}
                    />
                    <img src={menuSearchIcon} className={styles.search_icon} />
                </div>
            </div>

            <div className={styles.bottom}>
                <div className={styles.content_radio}>
                        {
                            content_category_list.map((item) => {
                                return (
                                    <div
                                        key={item.value}
                                        onClick={() => {handleContentChange(item.value)}}
                                        className={`${styles.content_radio_butn} ${item.active ? styles.content_radio_butn_active : ''}`}
                                    >
                                        <div
                                            className={styles.content_radio_text}
                                        >
                                            {item.label}
                                        </div>
                                        <div className={styles.underline}>

                                        </div>
                                    </div>
                                )
                            })
                        }
                </div>
            </div>
        </div>
    )
}

export default FilterBox